import React from "react";

import TimeslotRuleItem from "./TimeslotRuleItem";
import {
  TimeslotRuleAdbreakSelect,
  TimeslotRuleCountSelect,
  TimeslotRuleIncrementSelect,
  TimeslotRulePlaylistSelect,
  TimeslotRuleStartIndexSelect,
} from "./TimeslotRuleItemSelect";
import { TimeslotColumns } from "../../../types";

import type { JSX } from "react";
import type { ConnectDragSource } from "react-dnd";

import type { TimeslotSequentialRule } from "../../../api/FastAPI.types";

interface TimeslotRuleSequentialProps {
  rule: TimeslotSequentialRule;
  onClickDelete: (uuid: string) => void;
  isDragging: boolean;
  isDragDisabled: boolean;
  dragRef: ConnectDragSource;
}

function TimeslotRuleSequential({
  rule,
  onClickDelete,
  isDragging,
  dragRef,
  isDragDisabled,
}: TimeslotRuleSequentialProps): JSX.Element {
  const columns = {
    [TimeslotColumns.Rank]: rule.rank,
    [TimeslotColumns.Mode]: rule.mode,
    [TimeslotColumns.Source]: <TimeslotRulePlaylistSelect ruleId={rule.uuid} />,
    [TimeslotColumns.Count]: <TimeslotRuleCountSelect ruleId={rule.uuid} />,
    [TimeslotColumns.StartIndex]: (
      <TimeslotRuleStartIndexSelect ruleId={rule.uuid} />
    ),
    [TimeslotColumns.Increment]: (
      <TimeslotRuleIncrementSelect ruleId={rule.uuid} />
    ),
    [TimeslotColumns.Ads]: <TimeslotRuleAdbreakSelect ruleId={rule.uuid} />,
  };
  return (
    <TimeslotRuleItem
      columns={columns}
      dragRef={dragRef}
      isDragDisabled={isDragDisabled}
      isDragging={isDragging}
      onClickDelete={onClickDelete}
      uuid={rule.uuid}
    />
  );
}

export default TimeslotRuleSequential;
